import { ConfirmModal } from "components/modals";
import styles from "../purchase-order.module.scss";
import { Image, Text } from "components/commons";
import { ManChangeContent } from "images";
import locale from "localization";
const ChangeTypeModal = ({ ...modal }) => {
  return (
    <ConfirmModal {...modal} centerActions>
      <div className={styles.successModal}>
        <Image src={ManChangeContent} />
        <br />
        <Text strong className={styles.title}>
          {locale.changeProductType}
        </Text>
        <Text className={styles.message}>{locale.confirmChangeProductType}</Text>
      </div>
    </ConfirmModal>
  );
};

export default ChangeTypeModal;
